<section class="modal-content-container">
  @if (modalContentData()?.fromHome) {
  <div class="animated fadeInUp img-mushroom d-none d-lg-block d-md-block d-sm-none"></div>
  <div class="animated fadeInDown img-peaches d-none d-lg-block d-md-block d-sm-none"></div>
  <header class="text-center d-flex flex-column gap-3">    
    <h1 class="h1-bold animated fadeIn">
      <p class="m-0">See If We Deliver</p>
      <p class="m-0">To You<span class="dot-is-blue">.</span></p>
    </h1>
  </header>

  <article class="text-center px-5 mt-3">Enter your zip code to see if you're within our delivery radius</article>

  <section class="mt-5 mb-3 form-container">
    <h6 class="h7-semibold mb-1">
      EMAIL*
      <i class="fas fa-exclamation-circle text-primary me-2"></i>
    </h6>
    <div class="form-floating has-validation">
      <input type="email" class="form-control" id="email" name="email" autocomplete="one-time-code" placeholder="Enter your email"
        [class.is-invalid]="!emailValidation().valid && email.length > 0"
        [class.is-valid]="emailValidation().valid && email.length > 0" [value]="email" (input)="onEmailChange($event)"
        aria-describedby="email-help email-error" required>
      <label for="email">Email address</label>

      @if (!emailValidation().valid && email.length > 0) {
      <div class="invalid-feedback d-flex align-items-center" id="email-error">
        <i class="fas fa-exclamation-circle me-2"></i>
        {{ emailValidation().error }}
      </div>
      } @else if (emailValidation().valid && email.length > 0) {
      <div class="valid-feedback d-flex align-items-center">
        <i class="fas fa-check-circle me-2"></i>
        Looks good!
      </div>
      }
    </div>
  </section>
  }

  <section class="form-container">
    @if (modalContentData()?.fromHome) {
    <h6 class="h7-semibold mb-1">
      DELIVERY ADDRESS*
    </h6>
    }
    <div class="form-floating">
      <input #autocompleteInput type="text" autocomplete="one-time-code"
        [class.is-invalid]="!isLoadingContent() && (!hasDeliveryAddressCoverage() && isGoogleAddressFilled())"
        [class.is-valid]="!isLoadingContent() && hasDeliveryAddressCoverage()" class="form-control" id="address"
        (input)="changeAddress()" placeholder [(ngModel)]="queryString">
      <label for="address">Please enter your delivery address</label>
      @if (isLoadingContent()) {
      <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
      } @else {
      @if (hasDeliveryAddressCoverage()) {
      <div class="valid-tooltip right-0">
        This address is in our delivery area!
      </div>
      } @else if (isGoogleAddressFilled()) {
      <div class="invalid-tooltip right-0">
        Oops! Your address isn't in our delivery zone.
      </div>
      }
      }
    </div>
    <small class="ms-1">
      <a href="https://www.google.com/maps/d/u/0/viewer?mid=1VHpXUF0dLsF4OhB1gC5zXDOYpSNrVGk"
        target="_blank" rel="noopener noreferrer" class="link-success link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">
        Click here
      </a>
      to view a map of our current delivery routes
    </small>
  </section>

  @if (modalContentData()?.fromHome){
  <div class="d-grid gap-2 col-md-6 mx-auto mt-5">
    <button type="button" class="btn btn-secondary rounded-pill py-3" (click)="checkDeliveryAddressCoverage()"
      [disabled]="!hasGoogleAddress() || !queryString">Let's Go!</button>
  </div>
  } @else {
  <div class="d-grid gap-2 col-md-6 mx-auto mt-5">
    <button type="button" class="btn btn-primary" (click)="checkDeliveryAddressCoverage()"
      [disabled]="!hasGoogleAddress() || !queryString">Check address</button>
    <small class="text-center mt-4">Already have an account?</small>
    <button type="button" class="btn btn-outline-primary" (click)="loginClickHandler()">Log in</button>
    <small class="text-center">
      <p>Don't have an account? <a href="/signup">Sign up here</a></p>
    </small>
  </div>
  }
</section>